<!-- Vista principal de la App -->
<template>
  <v-app>
    <CuadroDeDialogo />
    <router-view />
  </v-app>
</template>

<script>

import CuadroDeDialogo from '@/components/CuadroDeDialogo.vue';

export default {
  name: 'App',
  components: { CuadroDeDialogo },
  data: () => ({
    //
  }),

  created() {
    document.title = 'Validador descuentos WEB';
  },

  methods: {
  },

};
</script>

<style>

</style>